import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "../routes";

// pages
// import Presentation from "./Presentation";
import DashboardOverview from "./dashboard/DashboardOverview";
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
// import NotFoundPage from "./examples/NotFound";
/* import ServerError from "./examples/ServerError"; */
import Login from "./Login";
import ProtectedRoute from "../components/ProtectedRoute";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";

/* import Accordion from "./components/Accordion";
import Alerts from "./components/Alerts";
import Badges from "./components/Badges";
import Breadcrumbs from "./components/Breadcrumbs";
import Buttons from "./components/Buttons";
import Forms from "./components/Forms";
import Modals from "./components/Modals";
import Navs from "./components/Navs";
import Navbars from "./components/Navbars";
import Pagination from "./components/Pagination";
import Popovers from "./components/Popovers";
import Progress from "./components/Progress";
import Tables from "./components/Tables";
import Tabs from "./components/Tabs";
import Tooltips from "./components/Tooltips";
import Toasts from "./components/Toasts";
import Users from './components/Users'; */
import UserReports from './components/UserReports';
/* import UsersList from './user/OldUsersList'; */
import EditUser from './user/EditUser';
import MyProfile from './MyProfile';
import UserReportsList from './user/UserReportsList';
import ReportDetail from './user/ReportDetail';
import MyReports from './user/MyReports';
import NewsList from './news/NewsList';
import NewsForm from './news/NewsForm';
import ContentList from './content-page/ContentList';
import ContentForm from './content-page/ContentForm';
import TestimonialList from './testimonials/TestimonialList';
import TestimonialForm from './testimonials/testimonialform';
import NewUserList from './user/UserList';
import UserForm from './user/UserForm';
import { GroupsList, GroupDetails, GroupForm } from './groups';
import MyProfileForm from './user/MyProfile';
import SubscriptionList from './subscription-management/list';
import UserDetails from './user/UserDetails';

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => ( <> <Preloader show={loaded ? false : true} /> <Component {...props} /> </> ) } />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <Preloader show={loaded ? false : true} />
        <Sidebar />

        <main className="content">
          <Navbar />
          <Component {...props} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
    )}
    />
  );
};

// NEW: Protected Route with Sidebar - combines protection + sidebar layout
const ProtectedRouteWithSidebar = ({ component: Component, ...rest }) => {
  return (
    <ProtectedRoute>
      <RouteWithSidebar component={Component} {...rest} />
    </ProtectedRoute>
  );
};

const HomePage = () => (
  <Switch>
    {/* PUBLIC ROUTES - No protection needed */}
    <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
    <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
    <RouteWithLoader exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
    <RouteWithLoader exact path={Routes.ResetPassword.path} component={ResetPassword} />
    <RouteWithLoader exact path={Routes.Lock.path} component={Lock} />
    {/* <RouteWithLoader exact path={Routes.NotFound.path} component={NotFoundPage} /> */}
    {/* <RouteWithLoader exact path={Routes.ServerError.path} component={ServerError} /> */}
    <RouteWithLoader exact path={Routes.Login.path} component={Login} />

    {/* PROTECTED ROUTES - Require authentication */}
    <ProtectedRouteWithSidebar exact path={Routes.DashboardOverview.path} component={DashboardOverview} />
    {/* <ProtectedRouteWithSidebar exact path={Routes.Upgrade.path} component={Upgrade} />
    <ProtectedRouteWithSidebar exact path={Routes.Transactions.path} component={Transactions} />
    <ProtectedRouteWithSidebar exact path={Routes.Settings.path} component={Settings} />
    <ProtectedRouteWithSidebar exact path={Routes.BootstrapTables.path} component={BootstrapTables} /> */}

    {/* PROTECTED COMPONENT ROUTES */}
    {/* <ProtectedRouteWithSidebar exact path={Routes.Accordions.path} component={Accordion} />
    <ProtectedRouteWithSidebar exact path={Routes.Alerts.path} component={Alerts} />
    <ProtectedRouteWithSidebar exact path={Routes.Badges.path} component={Badges} />
    <ProtectedRouteWithSidebar exact path={Routes.Breadcrumbs.path} component={Breadcrumbs} />
    <ProtectedRouteWithSidebar exact path={Routes.Buttons.path} component={Buttons} />
    <ProtectedRouteWithSidebar exact path={Routes.Forms.path} component={Forms} />
    <ProtectedRouteWithSidebar exact path={Routes.Modals.path} component={Modals} />
    <ProtectedRouteWithSidebar exact path={Routes.Navs.path} component={Navs} />
    <ProtectedRouteWithSidebar exact path={Routes.Navbars.path} component={Navbars} />
    <ProtectedRouteWithSidebar exact path={Routes.Pagination.path} component={Pagination} />
    <ProtectedRouteWithSidebar exact path={Routes.Popovers.path} component={Popovers} />
    <ProtectedRouteWithSidebar exact path={Routes.Progress.path} component={Progress} />
    <ProtectedRouteWithSidebar exact path={Routes.Tables.path} component={Tables} />
    <ProtectedRouteWithSidebar exact path={Routes.Tabs.path} component={Tabs} />
    <ProtectedRouteWithSidebar exact path={Routes.Tooltips.path} component={Tooltips} />
    <ProtectedRouteWithSidebar exact path={Routes.Toasts.path} component={Toasts} /> */}
    {/* <ProtectedRouteWithSidebar exact path={Routes.Users.path} component={Users} />
    <ProtectedRouteWithSidebar exact path={Routes.UsersList.path} component={UsersList} /> */}
    <ProtectedRouteWithSidebar exact path={Routes.EditUser.path} component={EditUser} />
    <ProtectedRouteWithSidebar exact path={Routes.MyProfile.path} component={MyProfile} />
    <ProtectedRouteWithSidebar exact path={Routes.UsersReportsList.path} component={UserReportsList} />
    <ProtectedRouteWithSidebar exact path={Routes.UserReports.path} component={UserReports} />
    <ProtectedRouteWithSidebar exact path={Routes.UserDetails.path} component={UserDetails} />
    {/* News */}
    <ProtectedRouteWithSidebar exact path={Routes.NewsList.path} component={NewsList} />
    <ProtectedRouteWithSidebar exact path={Routes.NewsNew.path} component={NewsForm} />
    <ProtectedRouteWithSidebar exact path={Routes.NewsEdit.path} component={NewsForm} />
    {/* Content */}
    <ProtectedRouteWithSidebar exact path={Routes.ContentList.path} component={ContentList} />
    <ProtectedRouteWithSidebar exact path={Routes.ContentEdit.path} component={ContentForm} />
    {/* Testimonials */}
    <ProtectedRouteWithSidebar exact path={Routes.TestimonialsList.path} component={TestimonialList} />
    <ProtectedRouteWithSidebar exact path={Routes.TestimonialsNew.path} component={TestimonialForm} />
    <ProtectedRouteWithSidebar exact path={Routes.TestimonialsEdit.path} component={TestimonialForm} />
    {/* New Users */}
    <ProtectedRouteWithSidebar exact path={Routes.NewUsersList.path} component={NewUserList} />
    <ProtectedRouteWithSidebar exact path={Routes.UserEdit.path} component={UserForm} />
    
    {/* Groups */}
    <ProtectedRouteWithSidebar exact path={Routes.GroupsList.path} component={GroupsList} />
    <ProtectedRouteWithSidebar exact path={Routes.GroupDetails.path} component={GroupDetails} />
    <ProtectedRouteWithSidebar exact path={Routes.GroupCreate.path} component={GroupForm} />
    <ProtectedRouteWithSidebar exact path={Routes.GroupEdit.path} component={GroupForm} />
    <ProtectedRouteWithSidebar exact path={Routes.MyProfileEdit.path} component={MyProfileForm} />
    {/* Subscription Management */}
    <ProtectedRouteWithSidebar exact path={Routes.SubscriptionList.path} component={SubscriptionList} />
    {/* Reports detail */}
    <ProtectedRouteWithSidebar exact path={Routes.ReportDetail.path} component={ReportDetail} />
    {/* My reports */}
    <ProtectedRouteWithSidebar exact path={Routes.MyReports.path} component={MyReports} />

    {/* Default redirect to login if no route matches */}
    <Redirect to={Routes.Login.path} />
  </Switch>
);

export default HomePage;